var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 11L9 7.24996C9 5.73117 10.2312 4.49995 11.75 4.49996L12.25 4.49997C13.7688 4.49998 15 5.7312 15 7.24997V11H15.25C16.7688 11 18 12.2312 18 13.75V16.75C18 18.2688 16.7688 19.5 15.25 19.5H8.75C7.23122 19.5 6 18.2688 6 16.75V13.75C6 12.2312 7.23122 11 8.75 11H9ZM10.5 11L10.5 7.24996C10.5 6.5596 11.0597 5.99995 11.75 5.99996L12.25 5.99997C12.9404 5.99997 13.5 6.55962 13.5 7.24997V11H10.5ZM11.0005 15.2169C10.9962 15.3482 11.0178 15.479 11.064 15.6019C11.1102 15.7248 11.1802 15.8375 11.2699 15.9333C11.3596 16.0292 11.4674 16.1065 11.587 16.1607C11.7066 16.215 11.8357 16.2451 11.9669 16.2495C12.0982 16.2538 12.229 16.2322 12.3519 16.186C12.4748 16.1398 12.5875 16.0698 12.6833 15.9801C12.7792 15.8904 12.8565 15.7826 12.9107 15.663C12.965 15.5434 12.9951 15.4143 12.9995 15.2831C13.0038 15.1518 12.9822 15.021 12.936 14.8981C12.8898 14.7752 12.8198 14.6625 12.7301 14.5667C12.6404 14.4708 12.5326 14.3935 12.413 14.3393C12.2934 14.285 12.1643 14.2549 12.0331 14.2505C11.9018 14.2462 11.771 14.2678 11.6481 14.314C11.5252 14.3602 11.4125 14.4302 11.3167 14.5199C11.2208 14.6096 11.1435 14.7174 11.0893 14.837C11.035 14.9566 11.0049 15.0857 11.0005 15.2169Z",
    fill: "#2c8ec6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassIcon);
export default __webpack_public_path__ + "static/media/passIcon.f3f9e559f4cf6ff741135e521ce2bc7f.svg";
export { ForwardRef as ReactComponent };